import { Button, Center, Divider, Stack } from '@chakra-ui/react';
import { ComponentProps, Fragment, memo } from 'react';

interface NumberInputDropdownContentProps {
  options: (number | string)[];
  onClick: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
  selectedIndex: number;
  dropdownContentProps?: Partial<ComponentProps<typeof Stack>>;
  dropdownButtonProps?: Partial<ComponentProps<typeof Button>>;
}

export const NumberInputDropdownContent = memo(
  ({ options, onClick, selectedIndex, dropdownContentProps, dropdownButtonProps }: NumberInputDropdownContentProps) => {
    return (
      <Stack p={2} spacing={0} maxH={'calc(100vh - 200px)'} overflow={'auto'} {...dropdownContentProps}>
        {options.map((opt, i) => (
          // Add divider if option is last index and string type
          <Fragment key={opt}>
            {i === options.length - 1 && typeof opt === 'string' && (
              <Center height='16px'>
                <Divider orientation='horizontal' />
              </Center>
            )}
            <Button
              onClick={onClick}
              data-value={opt}
              size={'xs'}
              position='relative'
              isActive={i === selectedIndex}
              variant={'toolbar-dropdown-item'}
              justifyContent={'center'}
              minH={'1.5rem'}
              {...dropdownButtonProps}
            >
              {opt}
            </Button>
          </Fragment>
        ))}
      </Stack>
    );
  },
);
NumberInputDropdownContent.displayName = 'NumberInputDropdownContent';
